export const UMB_MEMBER_GROUP_TABLE_COLLECTION_VIEW_ALIAS = 'Umb.CollectionView.MemberGroup.Table';
